<div class="new-item-modal">
  <h3 class="mat-h3">Add new folder</h3>
  <form class="form-field-full" [formGroup]="newFolderForm">
    <div class="form-inputs">
      <mat-form-field class="gingr-input-wrapper w-full">
        <input
          matInput
          placeholder="Folder name"
          type="text"
          formControlName="name"
          required />
        @if (name.invalid) {
          <mat-error>
            @if (name.errors?.required) {
              <span>Please enter folder name</span>
            }
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="gingr-input-wrapper w-full">
        <mat-select formControlName="status" placeholder="Select status">
          @for (st of statuses; track st) {
            <mat-option [value]="st">
              {{ st | titlecase }}
            </mat-option>
          }
        </mat-select>
        @if (status.invalid) {
          <mat-error>
            @if (status.errors?.required) {
              <span>Please provide status
              </span>
            }
          </mat-error>
        }
      </mat-form-field>

    </div>
    <button
      class=""
      mat-raised-button
      color="accent"
      [disabled]="newFolderForm.invalid"
      (click)="addNewItem()">
      Add new folder
    </button>
  </form>
</div>
